import React, { useEffect, useState } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { bannerList } from '../services/General-service';
import { Link } from 'react-router-dom';

function getRemainingSeconds(endsAt) {
    if (!endsAt) return 0;
    const endMs = new Date(endsAt).getTime();
    if (Number.isNaN(endMs)) return 0;
    return Math.max(0, Math.floor((endMs - Date.now()) / 1000));
}

function formatCountdown(totalSeconds) {
    const seconds = Math.max(0, Number(totalSeconds) || 0);
    const days = Math.floor(seconds / 86400);
    const hours = Math.floor((seconds % 86400) / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    return {
        days: String(days).padStart(2, '0'),
        hours: String(hours).padStart(2, '0'),
        minutes: String(minutes).padStart(2, '0'),
        seconds: String(secs).padStart(2, '0'),
    };
}

function BannerCountdown({ endsAt }) {
    const [remaining, setRemaining] = useState(() => getRemainingSeconds(endsAt));

    useEffect(() => {
        setRemaining(getRemainingSeconds(endsAt));
        if (!endsAt) return undefined;

        const tick = setInterval(() => {
            const next = getRemainingSeconds(endsAt);
            setRemaining(next);
            if (next <= 0) clearInterval(tick);
        }, 1000);

        return () => clearInterval(tick);
    }, [endsAt]);

    if (remaining <= 0) return null;

    const parts = formatCountdown(remaining);

    return (
        <div className="banner-countdown-overlay" onClick={(e) => e.preventDefault()}>
            <div className="banner-countdown">
                <div className="banner-countdown-unit">
                    <span className="banner-countdown-value">{parts.days}</span>
                    <span className="banner-countdown-label">DAYS</span>
                </div>
                <div className="banner-countdown-sep">:</div>
                <div className="banner-countdown-unit">
                    <span className="banner-countdown-value">{parts.hours}</span>
                    <span className="banner-countdown-label">HRS</span>
                </div>
                <div className="banner-countdown-sep">:</div>
                <div className="banner-countdown-unit">
                    <span className="banner-countdown-value">{parts.minutes}</span>
                    <span className="banner-countdown-label">MIN</span>
                </div>
                <div className="banner-countdown-sep">:</div>
                <div className="banner-countdown-unit">
                    <span className="banner-countdown-value">{parts.seconds}</span>
                    <span className="banner-countdown-label">SEC</span>
                </div>
            </div>
        </div>
    );
}

function Banner({ showBanner }) {
    const [currentSlide, setCurrentSlide] = useState(0);

    const CustomPrevArrow = ({ className, style, onClick, isDisabled }) => (
        <button
            className={className}
            style={{
                ...style,
                display: isDisabled ? "none" : "block",
            }}
            onClick={!isDisabled ? onClick : null}
        />
    );

    const CustomNextArrow = ({ className, style, onClick }) => (
        <button className={className} style={{ ...style }} onClick={onClick} />
    );

    const settings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        beforeChange: (oldIndex, newIndex) => setCurrentSlide(newIndex),
        prevArrow: <CustomPrevArrow isDisabled={currentSlide === 0} />,
        nextArrow: <CustomNextArrow />,
    };

    const [bannerArr, setBannerArr] = useState([]);
    const [loading, setLoading] = useState(true);

    const getBannerList = () => {
        bannerList('')
            .then((data) => {
                const list = Array.isArray(data?.data) ? data.data : [];
                setBannerArr(list);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching banner list:", error);
                setBannerArr([]);
                setLoading(false);
            });
    };

    useEffect(() => {
        getBannerList();
    }, []);

    if (!showBanner) return null;
    if (loading && !bannerArr.length) return null;

    return (
        <div className='banner-sec App'>
            <div className="BreakPointContainer">
                {bannerArr?.length > 0 && (
                    <Slider className='owl-theme' {...settings}>
                        {bannerArr.map((data, index) => {
                            const showTimer = Boolean(data?.timer_active && data?.timer_ends_at);
                            const bannerUrl = data?.url ? String(data.url) : '#';

                            return (
                                <div className='item' key={data?.id || index}>
                                    <Link to={bannerUrl} className="banner-slide-link">
                                        <div className="DynamicHeightLoaderWrapper banner-slide-media">
                                            <div className="DynamicHeightLoader layout align-center justify-center" style={{ paddingTop: '46%' }}>
                                                <img
                                                    src={data.banner_image}
                                                    alt={data.title || 'banner'}
                                                    className='img-resp DynamicHeightLoaderImage'
                                                    style={{ padding: '0px' }}
                                                />
                                                <div className="animated-bg-placeholder lg-animated-bg-placeholder"></div>
                                                {showTimer ? <BannerCountdown endsAt={data.timer_ends_at} /> : null}
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            );
                        })}
                    </Slider>
                )}
            </div>
        </div>
    );
}

export default Banner;
